import { nonEmptyTrimmedStringFromUnknown } from "../protocol/shared.js";
import { runtimeCoordinatorExecutionRecordSchema } from "../daemon/runtime-coordinator-execution.js";
import { agentInteractionResponseSchema } from "../protocol/agent-interaction.js";
import { runtimeTransportRuntimeCoordinatorRespondInteractionResponseSchema } from "../daemon/runtime-transport.js";
import * as z$1 from "zod/v4";
//#region src/schemas/http/space-agent-interaction.ts
const respondToSpaceAgentInteractionBodySchema = z$1.strictObject({
	runtimeCoordinatorExecutionId: runtimeCoordinatorExecutionRecordSchema.shape.runtimeCoordinatorExecutionId,
	interactionId: z$1.string().trim().min(1).max(256),
	response: agentInteractionResponseSchema
});
const respondToSpaceAgentInteractionInputSchema = z$1.strictObject({
	body: respondToSpaceAgentInteractionBodySchema,
	spaceId: nonEmptyTrimmedStringFromUnknown
});
const respondToSpaceAgentInteractionResponseSchema = runtimeTransportRuntimeCoordinatorRespondInteractionResponseSchema;
//#endregion
export { respondToSpaceAgentInteractionBodySchema, respondToSpaceAgentInteractionInputSchema, respondToSpaceAgentInteractionResponseSchema };

//# sourceMappingURL=space-agent-interaction.js.map